import React from 'react';
import EmailActions from './EmailActions';

function CollectionReportEmailActions({
  customerId,
  report,
  disabled = false,
  loading = false,
  buttonClassName = 'button small blue',
  successMessage,
  onSent,
  onError,
  onLoadingChange,
}) {
  const customerName = report?.customerName || '';
  const filenameName = String(customerName || 'Customer').replace(/[^a-z0-9]+/gi, '_');
  return (
    <EmailActions
      endpoint={customerId && report ? `/customers/${customerId}/collection-report/email` : ''}
      templateKey="collectionReport"
      templateValues={{
        document: 'Collection Report',
        documentNumber: '',
        recipientName: customerName,
        customerName,
      }}
      recipient={report?.customerEmail || ''}
      subject={`Collection Report - ${customerName}`.trim()}
      quickTitle="Send Collection Report"
      quickPrompt="Send collection report to:"
      attachmentPdf={`Collection_Report_${filenameName}.pdf`}
      attachmentExcel={`Collection_Report_${filenameName}.xlsx`}
      disabled={disabled || !customerId || !report}
      loading={loading}
      buttonClassName={buttonClassName}
      successMessage={successMessage}
      onLoadingChange={onLoadingChange}
      onSent={onSent}
      onError={onError}
    />
  );
}

export default CollectionReportEmailActions;
